module.exports = __webpack_public_path__ + "img/legend_hr.0b096654.svg";